module.exports = __webpack_public_path__ + "assets/img/o6.bc4b148.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/o6.jpg
// module id = lhS+
// module chunks = 1